import { useMemo } from 'react';
import {
  isB2BStock,
  isDSVStock,
  isSFPStock,
  isStock,
} from 'modules/user-has-permission/user-has-permission';
import { useUser } from 'hooks/redux/useUser';
import { useGroups } from 'hooks/redux/useGroups';

export function useGroupIdFilters() {
  const { user } = useUser();
  const { groups } = useGroups();
  const userIsStock = useMemo(() => isStock(), []);
  const userIsB2BStock = useMemo(() => isB2BStock(), []);
  const userIsDSVStock = useMemo(() => isDSVStock(), []);
  const userIsSFPStock = useMemo(() => isSFPStock(), []);

  return useMemo(
    () => ({
      ...(userIsStock
        ? {
            in: userIsB2BStock
              ? groups.find((group) => group.name === 'b2b')?.id
              : userIsDSVStock
              ? groups.find((group) => group.name === 'dsv')?.id
              : userIsSFPStock
              ? groups.find((group) => group.name === 'sfp')?.id
              : user.group_id,
          }
        : {}),
    }),
    [user, userIsStock, userIsDSVStock, userIsSFPStock, userIsB2BStock, groups],
  );
}
